/**
 * Boîte à outils — texte de physique écrit simplement (« E_c », « d_R », « v⃗ », « Δv⃗ ») et
 * affiché proprement : indices en <sub>, flèche de vecteur posée au-dessus de la lettre (la
 * flèche combinante U+20D7 n'existe pas dans les polices de l'app). Espaces insécables à la
 * française. Le texte lu par un lecteur d'écran reste le texte d'origine.
 */

import type { ReactNode } from 'react';
import { frenchSpaces } from './format';

const VEC = '⃗';
// une lettre (ou Δ suivi d'une lettre) surmontée d'une flèche, ou un indice « X_abc »
const TOKEN = new RegExp(`(Δ?[A-Za-z])${VEC}|([A-Za-zΔ])_([A-Za-z0-9]+)`, 'g');

export function richNodes(text: string): ReactNode[] {
  const s = frenchSpaces(text);
  const out: ReactNode[] = [];
  let last = 0;
  let k = 0;
  for (const m of s.matchAll(TOKEN)) {
    const i = m.index ?? 0;
    if (i > last) out.push(s.slice(last, i));
    if (m[1]) {
      out.push(
        <span key={k++} className="relative inline-block">
          {m[1]}
          <span
            aria-hidden
            className="pointer-events-none absolute inset-x-0 -top-[0.58em] text-center text-[0.72em] leading-none"
          >
            →
          </span>
        </span>,
      );
    } else {
      out.push(
        <span key={k++}>
          {m[2]}
          <sub className="text-[0.72em]">{m[3]}</sub>
        </span>,
      );
    }
    last = i + m[0].length;
  }
  if (last < s.length) out.push(s.slice(last));
  return out;
}

export function RichText({ children }: { children: string }) {
  return <>{richNodes(children)}</>;
}
